module.exports = __webpack_public_path__ + "static/img/banner.1f0145b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner.png
// module id = P07D
// module chunks = 12